import React from 'react'
import PropTypes from 'prop-types'

const Section = props => {
    const { children } = props

    return (
        <div className="row">
            <div className="column small-12">{children}</div>
        </div>
    )
}

Section.propTypes = {
    children: PropTypes.node,
}

export { Section }
